
<template>
  <div class="container-fluid">
    <div class="panel panel-info">
      <!-- <div style="text-align: left" class="p-3 mb-2 bg-secondary text-white">
        <b>Request For Transport Certificate :</b>
      </div> -->
       <div  class="p-3 mb-2">
        <h4 style="text-align: left">Transport Certificate
            <b-button class="float-right"  variant="danger" @click="handleBack"><b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>Back</b-button>
        </h4>
        
          
        <hr/>
      </div>
      <!-- <html>
<head>
  <title>Register Form</title>
</head>
<body> -->
      <form>
        <table>
          <tr>
            <td>Requester :</td>
            <td><input type="text" value = "Mr. Sunil Shinde" disabled/></td>
          </tr>
          <tr>
            <td>Contact no :</td>
            <td>
            
              <input type="phone" value = "+91 9920202020" disabled />
            </td>
          </tr>

          <tr>
            <td>Start Date :</td>
            <td><input type="text"  value = "01-12-2021 " disabled/></td>
          </tr>
          <tr>
            <td>End Date :</td>
            <td><input type="text"  value = "05-12-2021" disabled /></td>
          </tr>

          <tr>
            <td>Vehicle No :</td>
            <td><input type="text"  value = "MH01-3453" disabled/></td>
          </tr>
          <tr>
            <td>Vehicle Type :</td>
            <td><input type="text"  value = "Tempo" disabled /></td>
          </tr>
          <tr>
            <td>Transport From :</td>
            <td><input type="text"  value = "Satara" disabled /></td>
          </tr>
          <tr>
            <td>Transport To :</td>
            <td><input type="text"  value = "Pune " disabled /></td>
          </tr>
          <tr>
            <td>Driver Name :</td>
            <td><input type="text"  value = "Mr. Suraj Dalvi" disabled /></td>
          </tr>
          <td></td>
        </table>
       
      </form>
      <hr />
      <div class="col-12"> 
       <h5> Animal Details </h5>
      </div>
       <hr />
      <b-table
        show-empty
        empty-text="No Records Available"
        stacked="xs"
        bordered
        striped
        :items="item"
        :fields="fields"
        style="font-size: 12px"
      >
      </b-table>
      <!-- <button variant="primary" @click="handleSubmit">
      Download 
      </button>&nbsp; -->
        <button
          type="button"
          class="btn btn-xl btn-primary col-12 ;text-align:center;"
          @click="send_enquiry1"
        >
          Download
        </button> 
      <!-- <button variant="primary" @click="handleSubmit1">
        Reject
      </button> -->

      <!-- </body>
</html> -->
    </div>
  </div>
</template>
<script>
import * as _ from "lodash";
import DatePicker from "vue2-datepicker";
//import ApplicationFilter from "../components/ApplicationFilter.vue";
//import MarksEntry from "../components/MarksEntry.vue";
//alert(1);
export default {
  components: { DatePicker },
  data() {
    return {
      Observations: "",
      item: [
         { Tag_name: 40, type_name: 'Dickerson', is_medical: 'Yes' },
          {Tag_name: 21, type_name: 'Larsen', is_medical: 'No' },
          { Tag_name: 89, type_name: 'Geneva', is_medical: 'Pending' },
      ],
      fields: [
        { key: "Tag_name", label: "Tag No", sortable: true },
        { key: "type_name", label: "Type", sortable: true },
        // {
        //   key: "employee_category",
        //   label: "Employee Category",
        //   sortable: true,
        // },
        { key: "is_medical", label: " Medical Certificate" },
      ],
    };
  },
  computed: {},
  methods:  {
    handleSubmit() {
      alert("Approval Success");
    },
    handleSubmit1() {
      alert("Reject Success");
    },
  
    reset_details() {
      this.Observations = "";
    },
    handleBack(){
            this.$router.go(-1);
        },
  },
};
</script>

<style>
table {
  font-family: arial, sans-serif;

  width: 100%;
}

td,
th {
  border: 0px solid #dddddd;
  text-align: left;
  padding: 2px;
}
.mycard {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
